import i18n from "@/i18n"

const SEGMENT_KEY_MAP: Record<string, string> = {
  dashboard: "dashboard",
  appointments: "appointments",
  "slot-requests": "slotRequests",
  customers: "customers",
  services: "services",
  providers: "providers",
  finance: "finance",
  reports: "support",
  support: "support",
  "ad-campaigns": "adCampaigns",
  business: "business",
  "businesses": "businesses",
  "pending-approvals": "pendingApprovals",
  "pending-ad-campaigns": "pendingAdCampaigns",
  "admins": "admins",
  "messaging": "messaging",
  messages: "messages",
  "transactions": "transactions",
  "payouts": "payouts",
  "ad-plans": "adPlans",
  "industries": "industries",
  settings: "settings",
  profile: "profile",
  password: "password",
  appearance: "appearance",
  language: "language",
  notifications: "notifications",
  create: "create",
  edit: "edit",
  import: "import",
}

export function formatBreadcrumbSegment(segment: string): string {
  const key = SEGMENT_KEY_MAP[segment]
  if (key) {
    return i18n.t(`breadcrumbs.${key}`, { ns: "common", defaultValue: segment })
  }

  if (/^[a-f0-9]{24}$/i.test(segment)) {
    return i18n.t("breadcrumbs.details", { ns: "common", defaultValue: "Details" })
  }

  return segment
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}
